<template>
  <v-container>
    <v-card class="pa-4" max-width="full">
      <v-card-title>แสดงภาพข้อมูลการสอบ</v-card-title>
      <!-- <v-text-field
        v-model="store.subject"
        label="ชื่อวิชา"
        placeholder="NSSXXXX : XXXX"
        required
      /> -->
      <!-- <v-text-field v-model="store.startTime" label="Start Time" type="time" />
      <v-text-field
        v-model="store.finishTime"
        label="Finish Time"
        type="time"
      /> -->
      <v-row gap="4">
        <v-col cols="12" sm="6">
          <v-text-field
            variant="outlined"
            v-model="detail"
            label="รายละเอียดเพิ่มเติม (ถ้ามี)"
            placeholder="กฏต่างๆ เช่น ห้ามใช้เสียง, ห้ามใช้โทรศัพท์, ฯลฯ"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <v-btn class="mt-2" color="pink-lighten-1" @click="addDetail"
            >+</v-btn
          >
        </v-col>
      </v-row>
      <v-row gap="4">
        <v-col cols="12" sm="6" align-start justify-start>
          <ul>
            <li
              class="pa-2 ms-5 text-start"
              v-for="(item, index) in store.ExtraDetails"
              :key="index"
            >
              {{ item }}
              <v-btn
                variant="text"
                class="ms-5 text-red"
                icon="mdi-delete"
                @click="store.ExtraDetails.splice(index, 1)"
              >
              </v-btn>
            </li>
          </ul>
        </v-col>
      </v-row>

      <v-btn color="primary" block @click="openDisplay"> เปิดหน้าจอ </v-btn>
    </v-card>
  </v-container>
</template>

<script setup>
import { useClockStore } from "@/stores/clock";
import { ref } from "vue";
const store = useClockStore();
const detail = ref("");
const addDetail = () => {
  if (detail.value.trim() !== "") {
    store.ExtraDetails.push(detail.value.trim());
    detail.value = ""; // Clear the input field after adding
  }
};
const openDisplay = () => {
  // Use the route path for your clock display
  window.open("/clockDisplay", "_blank", "width=1920,height=1080");
};
</script>
